/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

const colorHexRegexp = /^#([a-fA-F0-9]{8}|[a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

/**
  * Validator function for hexademical colors
  *
  * @param {String} value The string to validate.
  * @return {Boolean} True if valid hex, else false.
  */
export const isColorHex = (value) => {
  if (typeof value !== 'string') {
    throw new TypeError('Expected a string to validate; instead got ' + typeof value);
  }

  return colorHexRegexp.test(value);
};

